import TipsBar from './src/index.vue'
TipsBar.install = function(Vue) {
  Vue.component(TipsBar.name, TipsBar)
}
export default TipsBar
